/**
 * Whether the app is running against the production environment.
 *
 * Read from runtime config (`window.__CONFIG__`, populated by
 * RuntimeConfigProvider before any route loads) rather than a build-time
 * flag, because the production web deploy is a promoted preview build — the
 * bundle cannot know at build time which environment it will serve.
 *
 * Used to keep review-only surfaces (wireframe routes, fixture panels) out of
 * production while leaving them up in dev / preview / staging.
 */
export const isProductionRuntime = (): boolean =>
  (typeof window !== 'undefined' && window.__CONFIG__
    ? (window.__CONFIG__ as { appEnv?: string }).appEnv
    : undefined) === 'production';
